import { TOKEN, USER_ID, APP_ID, MT_USER_INFO } from './constants';
import { isInMiniProgram } from './development';
import { bbtNative } from '@bbtfe/webview-bridge';
import { queryStringToObject } from './index';
import jscookie from 'js-cookie';
import { Base64 } from 'js-base64';
import queryString from '@utils/query-string';
import { queryUserInfos } from './services';

export const removeToken = () => {
  localStorage.removeItem(TOKEN);
};

export const setToken = token => {
  localStorage.setItem(TOKEN, token);
};

// 获取链接上的用户id -> enc-user-id
const getQueryUserId = () => {
  const query = queryString.parseUrl(window.location.href)?.query || {};
  return query['enc-user-id'];
};

const getMtUserInfo = () => {
  const userInfo = jscookie.get(MT_USER_INFO) || '';
  const [, appVersion = '', , loginString = '', , userId = ''] =
    userInfo.split(',');
  return {
    appVersion: Base64.decode(appVersion),
    loginString: Base64.decode(loginString),
    userId: Base64.decode(userId)
  };
};

/**
 * 获取当前环境下token.
 * ps: 微信中，localstorage中会缓存微信用户的token， 名称token会重合
 */
export const getToken = () => {
  return (
    bbtNative?.userinfo?.loginString ||
    window?.USER_INFO?.loginString ||
    localStorage.getItem(TOKEN) ||
    getMtUserInfo().loginString
  );
};
/**
 * 获取当前环境下userid
 */
export const getUserId = () => {
  return (
    getQueryUserId() ||
    bbtNative?.userinfo?.encUserId ||
    localStorage.getItem(USER_ID) ||
    getMtUserInfo().userId
  );
};

/**
 * 判断是否已登录
 */
export const isLogin = () => {
  return !!getToken();
};
/**
 * 获取当前环境下username
 */
export const getUserName = () => {
  let nickname = null;
  const BBT_USER_INFO = jscookie.get('BBT_USER_INFO');
  if (BBT_USER_INFO && BBT_USER_INFO != 'undefined' && BBT_USER_INFO != '') {
    const BBT_Array = BBT_USER_INFO.split(',');
    if (
      BBT_Array &&
      BBT_Array.length >= 3 &&
      BBT_Array[2] != null &&
      BBT_Array[2] != ''
    ) {
      nickname = Base64.decode(BBT_Array[2]);
    }
  }
  return nickname;
};
/**
 * 通过loginString
 * queryUidByloginStr
 */
export const queryUid = () => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!getToken()) {
        localStorage.setItem(USER_ID, '');
        resolve('');
        return;
      }
      const userinfo = await queryUserInfos({
        app_id: APP_ID,
        loginstring: getToken()
      });
      const { enc_userid } = userinfo;
      localStorage.setItem(USER_ID, enc_userid);
      resolve(enc_userid);
    } catch (e) {
      console.error(e);
      resolve('');
    }
  });
};

/**
 * 通过loginString查询用户信息
 */
export const queryUserInfo = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const userinfo = await queryUserInfos({
        app_id: APP_ID,
        loginstring: getToken()
      });
      resolve(userinfo);
    } catch (e) {
      console.error(e);
      resolve('');
    }
  });
};

/**
 * 在小程序中获取用户信息；
 */
export const initMiniUserByToken = () => {
  if (!isInMiniProgram()) {
    return;
  }
  const query = queryStringToObject(window.location.search);
  const { token } = query;
  const { flag } = query; // 标记来自三方页面回跳， 如：minsheng
  if (flag) return;
  const oldToken = localStorage.getItem(TOKEN);
  console.log('这是小程序的登录~', token, oldToken);
  if (token !== oldToken) {
    setToken(token);
    queryUid();
  }
};
